"use client";

import dynamic from "next/dynamic";

export const ApiCalculatorDynamic = dynamic(() =>
  import("@ui/components/pricing/PricingCalculator/ApiCalculator").then(mod => ({ default: mod.ApiCalculator })),
);
